export interface Movie {
  id: number;
  title: string;
  year: number;
  genre: string;
  rating: number;
  poster: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  isHot: boolean;
  isNew: boolean;
  type: 'movie' | 'series';
  episodeInfo?: string;
}

export const genres = [
  { key: 'all', label: '全部' },
  { key: 'action', label: '动作' },
  { key: 'comedy', label: '喜剧' },
  { key: 'drama', label: '剧情' },
  { key: 'scifi', label: '科幻' },
  { key: 'horror', label: '恐怖' },
  { key: 'romance', label: '爱情' },
  { key: 'animation', label: '动画' },
  { key: 'documentary', label: '纪录片' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    year: 2026,
    genre: 'scifi',
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20style%2C%20astronaut%20floating%20in%20deep%20space%20with%20galaxy%20nebula%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20tones%20with%20blue%20and%20gold%20accents%2C%20movie%20poster%20aesthetic%2C%20minimalist%20design&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    description: '在遥远的未来，人类文明已经遍布银河系。一支精英宇航员小队踏上了前往未知星域的旅程，他们不仅要面对宇宙中的各种危险，还要在极限环境中坚守人性的光辉。这是一部关于勇气、探索和希望的科幻史诗巨制。',
    director: '张宇航',
    cast: ['刘德华', '吴京', '章子怡', '黄渤'],
    duration: '148分钟',
    isHot: true,
    isNew: true,
    type: 'movie',
  },
  {
    id: 2,
    title: '笑傲江湖之风云再起',
    year: 2026,
    genre: 'action',
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20action%20movie%20poster%2C%20warrior%20with%20sword%20standing%20on%20mountain%20peak%20at%20sunset%2C%20flowing%20robes%20in%20wind%2C%20dramatic%20orange%20and%20gold%20sky%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20aesthetic%2C%20movie%20poster%20style&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    description: '江湖恩怨，风云再起。一位退隐多年的剑客被迫重出江湖，面对昔日的仇敌和新的威胁。在这条充满刀光剑影的道路上，他将重新定义什么是真正的侠义精神。',
    director: '陈凯歌',
    cast: ['甄子丹', '李连杰', '周迅', '彭于晏'],
    duration: '135分钟',
    isHot: true,
    isNew: true,
    type: 'movie',
  },
  {
    id: 3,
    title: '深夜食堂',
    year: 2026,
    genre: 'drama',
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese-style%20small%20restaurant%20at%20night%2C%20chef%20cooking%20behind%20counter%2C%20steaming%20food%20under%20warm%20yellow%20light%2C%20intimate%20atmosphere%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20nostalgic%20mood%2C%20minimalist&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    description: '城市的一隅，有一家只在深夜营业的小餐馆。每个深夜到访的食客，都带着自己的故事而来。一碗热腾腾的面条，一份简单的炒饭，温暖了无数孤独的灵魂。',
    director: '王家卫',
    cast: ['梁朝伟', '汤唯', '张曼玉', '金城武'],
    duration: '120分钟',
    isHot: false,
    isNew: true,
    type: 'movie',
  },
  {
    id: 4,
    title: '极限追击',
    year: 2026,
    genre: 'action',
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Fast-paced%20action%20thriller%20movie%20poster%2C%20man%20running%20through%20city%20streets%20at%20night%20with%20explosions%20behind%2C%20rainy%20urban%20environment%2C%20neon%20lights%2C%20intense%20dynamic%20composition%2C%20dark%20cinematic%20style%2C%20adrenaline%20fueled%20action&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    description: '一名退役特种兵发现了一个惊天阴谋，他必须在48小时内阻止一场灾难的发生。全城追捕、惊险逃脱、终极对决，一场紧张刺激的极限追击就此展开。',
    director: '林超贤',
    cast: ['张译', '段奕宏', '王千源', '李现'],
    duration: '128分钟',
    isHot: true,
    isNew: false,
    type: 'movie',
  },
  {
    id: 5,
    title: '欢乐喜剧人',
    year: 2025,
    genre: 'comedy',
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20movie%20poster%2C%20group%20of%20friends%20laughing%20together%20in%20vibrant%20city%20setting%2C%20warm%20sunny%20lighting%2C%20joyful%20expressions%2C%20playful%20cinematic%20composition%2C%20feel-good%20atmosphere%2C%20modern%20urban%20aesthetic&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    description: '五个性格迥异的朋友意外获得了一笔巨额奖金，但必须在一周内完成一系列令人啼笑皆非的挑战。笑料百出的冒险之旅，让人捧腹大笑的同时也感受到友情的温暖。',
    director: '徐峥',
    cast: ['沈腾', '马丽', '艾伦', '贾玲'],
    duration: '115分钟',
    isHot: false,
    isNew: false,
    type: 'movie',
  },
  {
    id: 6,
    title: '深海迷踪',
    year: 2025,
    genre: 'horror',
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Eerie%20underwater%20horror%20movie%20poster%2C%20dark%20ocean%20depths%20with%20mysterious%20glowing%20creature%20silhouette%2C%20submarine%20in%20distance%2C%20cold%20blue%20and%20black%20tones%2C%20atmospheric%20tension%2C%20cinematic%20thriller%20style%2C%20deep%20sea%20mystery&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    description: '一艘深海探测潜艇在太平洋深处失踪，搜救队在深海中发现了一个令人震惊的秘密。随着调查的深入，他们发现自己正在面对一种超越人类认知的恐怖存在。',
    director: '乌尔善',
    cast: ['陈坤', '舒淇', '黄晓明', '杨颖'],
    duration: '132分钟',
    isHot: false,
    isNew: false,
    type: 'movie',
  },
  {
    id: 7,
    title: '春风十里不如你',
    year: 2026,
    genre: 'romance',
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20love%20story%20movie%20poster%2C%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20and%20white%20petals%2C%20golden%20hour%20warm%20lighting%2C%20dreamy%20atmospheric%20cinematic%20style%2C%20tender%20romantic%20mood&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    description: '一部关于青春、梦想和爱情的温暖故事。两个年轻人在最美的年华相遇，经历了欢笑与泪水，最终明白了爱情的真谛。春风十里，不如你在我身边。',
    director: '张艺谋',
    cast: ['刘亦菲', '杨洋', '周冬雨', '易烊千玺'],
    duration: '125分钟',
    isHot: false,
    isNew: true,
    type: 'movie',
  },
  {
    id: 8,
    title: '龙族崛起',
    year: 2025,
    genre: 'animation',
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20movie%20poster%2C%20Chinese%20dragon%20soaring%20through%20clouds%20and%20mountains%2C%20vibrant%20colors%20with%20traditional%20Chinese%20art%20style%2C%20golden%20and%20red%20tones%2C%20mythological%20fantasy%20aesthetic%2C%20cinematic%20animated%20film%20poster&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    description: '在一个被巨龙守护的神秘世界中，一个普通少年意外唤醒了沉睡千年的龙族力量。他必须学会掌控这股力量，与伙伴们一起对抗黑暗势力，守护世界的和平。',
    director: '田晓鹏',
    cast: ['（配音）张杰', '（配音）季冠霖', '（配音）边江', '（配音）乔诗语'],
    duration: '108分钟',
    isHot: true,
    isNew: false,
    type: 'movie',
  },
  {
    id: 9,
    title: '破晓行动',
    year: 2026,
    genre: 'action',
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Military%20action%20movie%20poster%2C%20special%20forces%20team%20in%20tactical%20gear%20at%20dawn%2C%20silhouettes%20against%20orange%20sunrise%20sky%2C%20helicopters%20in%20background%2C%20intense%20cinematic%20style%2C%20gritty%20realistic%20aesthetic%2C%20epic%20scale&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    description: '一支精英特战小队接到秘密任务，深入敌后执行破晓行动。面对数量和装备上的绝对劣势，他们凭借智慧和勇气，完成了一次不可能的任务。',
    director: '吴京',
    cast: ['吴京', '张涵予', '段奕宏', '杜江'],
    duration: '142分钟',
    isHot: false,
    isNew: true,
    type: 'movie',
  },
  {
    id: 10,
    title: '地球脉动之旅',
    year: 2025,
    genre: 'documentary',
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20film%20poster%2C%20stunning%20aerial%20view%20of%20Earth%20landscapes%20showing%20mountains%20oceans%20and%20forests%2C%20vibrant%20natural%20colors%2C%20majestic%20wildlife%20silhouettes%2C%20cinematic%20documentary%20style%2C%20breathtaking%20planet%20earth%20aesthetic&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    description: '一部震撼人心的自然纪录片，带领观众穿越七大洲四大洋，领略地球上最壮丽的自然景观和最神奇的野生动植物。高清摄影技术捕捉到的每一个画面都令人叹为观止。',
    director: '陆川',
    cast: ['（旁白）陈道明'],
    duration: '98分钟',
    isHot: false,
    isNew: false,
    type: 'movie',
  },
  {
    id: 11,
    title: '大宋风云录',
    year: 2026,
    genre: 'drama',
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%2C%20ancient%20Chinese%20palace%20and%20officials%20in%20traditional%20Song%20dynasty%20robes%2C%20ink%20wash%20painting%20style%20background%2C%20dramatic%20lighting%2C%20elegant%20classical%20Chinese%20aesthetic%2C%20cinematic%20historical%20film&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    description: '以北宋时期为背景，讲述了一段波澜壮阔的历史故事。朝廷权谋、江湖义气、儿女情长交织在一起，勾勒出一幅宏大而细腻的时代画卷。',
    director: '曹盾',
    cast: ['陈道明', '张若昀', '李沁', '吴刚'],
    duration: '156分钟',
    isHot: true,
    isNew: true,
    type: 'movie',
  },
  {
    id: 12,
    title: '异能觉醒',
    year: 2025,
    genre: 'scifi',
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Superhero%20sci-fi%20movie%20poster%2C%20young%20man%20with%20energy%20powers%20emanating%20from%20hands%2C%20urban%20cityscape%20at%20night%2C%20electric%20glowing%20effects%2C%20dark%20cinematic%20composition%2C%20modern%20superhero%20film%20aesthetic%2C%20dramatic%20lighting&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    description: '一次意外事故让一名普通大学生获得了超乎常人的能力。他必须在隐藏身份和拯救世界之间做出选择，同时还要面对来自暗处的威胁。',
    director: '郭帆',
    cast: ['王一博', '赵丽颖', '雷佳音', '张小斐'],
    duration: '138分钟',
    isHot: false,
    isNew: false,
    type: 'movie',
  },
];

export const series: Movie[] = [
  {
    id: 101,
    title: '隐秘的角落',
    year: 2026,
    genre: 'drama',
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Suspenseful%20crime%20drama%20TV%20series%20poster%2C%20shadowy%20figure%20standing%20in%20narrow%20alley%20at%20night%2C%20dim%20street%20lamp%20lighting%2C%20mysterious%20atmosphere%2C%20dark%20cinematic%20style%2C%20neo-noir%20aesthetic%2C%20intense%20psychological%20thriller&width=600&height=900&seq=series-poster-01&orientation=portrait',
    description: '三个孩子在一次意外中目睹了一桩命案，从此他们的生活被彻底改变。随着真相一步步浮出水面，每个人内心的隐秘角落也逐渐被揭开。',
    director: '辛爽',
    cast: ['秦昊', '王景春', '张颂文', '刘琳'],
    duration: '12集',
    isHot: true,
    isNew: true,
    type: 'series',
    episodeInfo: '已完结',
  },
  {
    id: 102,
    title: '长安十二时辰',
    year: 2025,
    genre: 'action',
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20TV%20series%20poster%2C%20Tang%20dynasty%20Changan%20cityscape%20at%20sunset%2C%20warrior%20in%20traditional%20armor%2C%20epic%20scale%2C%20cinematic%20historical%20epic%20style%2C%20warm%20golden%20and%20red%20tones%2C%20grand%20palace%20architecture&width=600&height=900&seq=series-poster-02&orientation=portrait',
    description: '唐朝天宝三年，上元节前夕，长安城混入可疑人员。身陷囹圄的张小敬临危受命，需在十二个时辰内破除隐患，拯救全城百姓的性命。',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    duration: '48集',
    isHot: true,
    isNew: false,
    type: 'series',
    episodeInfo: '已完结',
  },
  {
    id: 103,
    title: '迷雾追踪',
    year: 2026,
    genre: 'horror',
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Mystery%20crime%20TV%20series%20poster%2C%20detective%20in%20raincoat%20standing%20in%20foggy%20forest%20at%20night%2C%20flashlight%20beam%2C%20eerie%20atmosphere%2C%20dark%20green%20and%20black%20tones%2C%20cinematic%20thriller%20style%2C%20suspenseful%20mood&width=600&height=900&seq=series-poster-03&orientation=portrait',
    description: '一座平静的小城连续发生离奇失踪案件，刑警队长与新人搭档深入调查，却发现案件背后隐藏着一个跨越二十年的惊天秘密。',
    director: '杨苗',
    cast: ['廖凡', '谭卓', '白宇', '倪妮'],
    duration: '24集',
    isHot: false,
    isNew: true,
    type: 'series',
    episodeInfo: '更新至18集',
  },
  {
    id: 104,
    title: '家有儿女新传',
    year: 2026,
    genre: 'comedy',
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=Family%20comedy%20TV%20series%20poster%2C%20happy%20Chinese%20family%20in%20modern%20apartment%20living%20room%2C%20bright%20warm%20lighting%2C%20joyful%20expressions%2C%20colorful%20decor%2C%20feel-good%20atmosphere%2C%20sitcom%20style%20cinematic%20composition&width=600&height=900&seq=series-poster-04&orientation=portrait',
    description: '经典情景喜剧的全新演绎，讲述新时代下一家五口的温馨日常。父母的育儿烦恼、孩子们的成长趣事，笑料不断又感人至深。',
    director: '林丛',
    cast: ['宋丹丹', '高亚麟', '张一山', '杨紫'],
    duration: '36集',
    isHot: false,
    isNew: true,
    type: 'series',
    episodeInfo: '更新至30集',
  },
];

export const allContent = [...movies, ...series];

export const getMoviesByGenre = (genre: string): Movie[] => {
  if (genre === 'all') return allContent;
  return allContent.filter(m => m.genre === genre);
};

export const getMovieById = (id: number): Movie | undefined => {
  return allContent.find(m => m.id === id);
};

export const getHotMovies = (): Movie[] => {
  return allContent.filter(m => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return allContent.filter(m => m.isNew);
};

export const getRelatedMovies = (movie: Movie, count: number = 6): Movie[] => {
  return allContent
    .filter(m => m.id !== movie.id && m.genre === movie.genre)
    .slice(0, count);
};